import { Alert, Group, Loader, Modal, Select, Stack, TextInput } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { IconCheck } from '@tabler/icons-react';
import Button from 'components/Button';
import UploadFile from 'components/files/UploadFile';
import { DateInput } from 'components/inputs/DateInput';

export interface HrRelatedTermFormValues {
  termTypeId: string;
  nextDueDate: string;
  recurrenceQuantity: number;
  recurrenceUnit: string;
  note: string;
  checkedVariantIds: number[];
  certificateId: string;
  certificateNumber: string;
  renewalDate: string;
  certificateFileId: string;
  stampFileId: string;
}

interface HrTermStateModalProps {
  mode: 'pair' | 'reactivate' | null;
  form: UseFormReturnType<HrRelatedTermFormValues>;
  certificateOptions: any[];
  certificateOptionsLoading: boolean;
  onClose: () => void;
  onSubmit: (event?: React.FormEvent<HTMLFormElement>) => void;
}

/** Modal-contained form for certificate pairing and term reactivation. */
export default function HrTermStateModal({
  mode,
  form,
  certificateOptions,
  certificateOptionsLoading,
  onClose,
  onSubmit,
}: HrTermStateModalProps) {
  return (
    <Modal
      opened={mode === 'pair' || mode === 'reactivate'}
      onClose={onClose}
      title={mode === 'pair' ? 'Spárovať osvedčenie' : 'Zaradiť termín'}
      size="lg"
    >
      <form onSubmit={onSubmit}>
        <Stack>
          {mode === 'pair' && (
            <>
              <Select
                size="md"
                label="Existujúce oprávnené osvedčenie (nepovinné)"
                clearable
                searchable
                withinPortal={false}
                disabled={certificateOptionsLoading}
                data={certificateOptions.map((option) => ({
                  value: String(option.certificateId),
                  label: `${option.certificateNumber} – obnova ${option.renewalDate}`,
                }))}
                {...form.getInputProps('certificateId')}
              />
              {certificateOptionsLoading && <Loader size="sm" aria-label="Načítavam oprávnené osvedčenia" />}
              {!form.values.certificateId && (
                <>
                  <TextInput
                    size="md"
                    label="Číslo osvedčenia"
                    withAsterisk
                    {...form.getInputProps('certificateNumber')}
                  />
                  <DateInput size="md" label="Dátum obnovy" withAsterisk {...form.getInputProps('renewalDate')} />
                  <UploadFile label="Osvedčenie" {...form.getInputProps('certificateFileId')} />
                  <UploadFile label="Pečiatka" {...form.getInputProps('stampFileId')} />
                </>
              )}
            </>
          )}
          {mode === 'reactivate' && (
            <>
              <Alert color="blue">Zaradenie vyžaduje platný najbližší termín.</Alert>
              <DateInput
                size="md"
                label="Najbližší termín po zaradení"
                withAsterisk
                required
                {...form.getInputProps('nextDueDate')}
              />
            </>
          )}
          <Group position="right" mt="md">
            <Button variant="subtle-gray" type="button" onClick={onClose}>
              Zrušiť
            </Button>
            <Button variant="primary" type="submit" leftIcon={<IconCheck stroke={1.5} />}>
              {mode === 'reactivate' ? 'Zaradiť' : 'Potvrdiť'}
            </Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  );
}
